import React, { useContext } from "react"
import { ThemeContext } from "../utility/context/ThemeContext"
import { Image, View } from "react-native"
import PoweredByOneEthosImageWhite from '../assets/images/PBOneEthosLogoWhite.png'
import PoweredByOneEthosImageBlack from '../assets/images/PBOneEthosLogoBlack.png'

const Footer = () => {
  const theme = useContext(ThemeContext).theme

  return (
    <View style={{
      height: 50,
      backgroundColor: theme.colors.footerBackground,
      justifyContent: "center",
      alignItems: "center",
    }}>
      <Image
        // source={theme.name == 'dark' ? PoweredByOneEthosImageWhite : PoweredByOneEthosImageBlack}
        source={PoweredByOneEthosImageWhite}
        style={{
          width: 200,
          height: 36,
        }}
        resizeMode='contain'
        resizeMethod='scale'
      />
    </View>
  )
}

export default Footer